import src from "IMAGE";
export default { src, width: 1680, height: 164, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
